/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Notetaker_DescInputs */



/**
* | output |
* | --- |
* | "A visible participant called Wundo joins and writes the report." |
*
* @param {Meetings_Notetaker_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_notetaker_desc = /** @type {((inputs?: Meetings_Notetaker_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Notetaker_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Een zichtbare deelnemer Wundo komt erbij en maakt het verslag.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un participant visible nommé Wundo rejoint la réunion et rédige le compte rendu.")
	return /** @type {LocalizedString} */ ("A visible participant called Wundo joins and writes the report.")
});